fragment LeadAssignable on Assignable {
    id
    name
    type
    ... on User {
        avatarUrl
        initials
    }
}
